var _rect, _path, _path2, _circle, _rect2, _rect3, _rect4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarbleThumbnailGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#D5D8DD",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-edge",
    d: "M1 11V17H47.5C48.6046 17 49.5 16.1046 49.5 15V1H11C5.47715 1 1 5.47715 1 11Z",
    fill: "#505862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-edge",
    d: "M101 91L101 85L44 85C42.8954 85 42 85.8954 42 87L42 101L91 101C96.5228 101 101 96.5228 101 91Z",
    fill: "#505862"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-ball",
    cx: 57.7119,
    cy: 51,
    r: 25.8607,
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 1.72149
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-ball",
    x: 19.7046,
    y: 56.3804,
    width: 10.3728,
    height: 4.44547,
    rx: 2.22273,
    fill: "#B9BEC6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-ball",
    x: 19.7046,
    y: 41.5591,
    width: 10.3728,
    height: 4.44547,
    rx: 2.22273,
    fill: "#B9BEC6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-ball",
    x: 16,
    y: 48.9712,
    width: 11.8546,
    height: 4.44547,
    rx: 2.22273,
    fill: "#B9BEC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1193 49.8067C81.5513 50.2079 81.5442 50.8937 81.1042 51.2859L66.2853 64.4938C65.4914 65.2014 64.2881 64.3449 64.6967 63.363L69.3208 52.2524C69.8192 51.055 69.8327 49.7108 69.3586 48.5035L65.0155 37.4446C64.6267 36.4546 65.8474 35.6225 66.6268 36.3464L81.1193 49.8067Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarbleThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MarbleThumbnailGray.2448cc2c6bfbda680ff44300f8a88acc.svg";